import Typography from '@alltrails/core/components/Typography';
import sanitizeHtml from '@alltrails/core/utils/sanitizeHtml';
import type { PageUICommunityInsightSection } from '../../../utils/PageUI/pageUI';
import styles from './PageUICommunityInsight.module.scss';

// The server wraps matched words in <em>; nothing else is expected or allowed
const sanitizeConfig = { ALLOWED_TAGS: ['em'] };

type Props = {
  section: PageUICommunityInsightSection;
};

/**
 * A review quote under its trail's card, titled so it reads as what the community said rather than the agent.
 */
export default function PageUICommunityInsight({ section }: Props) {
  const __html = sanitizeHtml(section.reviewHighlight.textWithHighlighting, sanitizeConfig);

  const title = 'Community insight'; // hwandrew TODO: XPLR-204 translations

  return (
    <div className={styles.insight}>
      <Typography component="span" variant="text100bold">
        {title}
      </Typography>
      <blockquote className={styles.quote} dangerouslySetInnerHTML={{ __html }} />
    </div>
  );
}
